const checkServerStatus = async () => {
	return await (await fetch(`${process.env.REACT_APP_SERVER_URL}/status`)).text();
};

/*
 response: {
    userid , pubid , msg
 }
*/
export const emitLoginEvent = async (uid, success, error) => {
	fetch(`${process.env.REACT_APP_SERVER_URL}/login`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"API-Auth-Key": process.env.REACT_APP_SERVER_API_AUTH_KEY,
		},
		body: JSON.stringify({
			userid: uid,
		}),
	})
		.then((response) => {
			// const txt = await response.text();
			// console.log(txt);
			success(response);
		})
		.catch((error) => console.log("Request failed", error));
};

export const postMessage = (pubid, message, success, error) => {
	fetch(`${process.env.REACT_APP_SERVER_URL}/post`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"API-Auth-Key": process.env.REACT_APP_SERVER_API_AUTH_KEY,
		},
		body: JSON.stringify({
			pubid: pubid,
			msg: message,
		}),
	})
		.then((response) => {
			success(response);
		})
		.catch((err) => {
			error(err);
		});
};

export const getMessages = (uid, start, length, success, error) => {
	// Convert parameters to a query string
	const queryString = `userid=${encodeURIComponent(uid)}&page=${encodeURIComponent(start)}&per_page=${encodeURIComponent(length)}`;

	// Append the query string to the URL
	const url = `${process.env.REACT_APP_SERVER_URL}/messages?${queryString}`;

	fetch(url, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			"API-Auth-Key": process.env.REACT_APP_SERVER_API_AUTH_KEY,
		},
	})
		.then((response) => {
			success(response);
		})
		.catch((err) => {
			error(err);
		});
};

//test
// emitLoginEvent(
// 	"testuid",
// 	() => {

//     },
// 	() => {}
// );

// const a = async () => {
//     const ff = await checkServerStatus();
//     console.log(ff)
// }

// a()

// postMessage(
// 	"b530f662520da146590a943442878976b0cbd3602f1f9d344a380720da941379",
// 	"hello this is vishnu",
// 	(r) => {
// 		// const a = r.json();
// 		// console.log(a);
// 	},
// 	(e) => {
// 		// console.log(e);
// 	}
// );

// getMessages("testuid", "1", "10", (r) => {});
